export function logInfo(...args: any[]) {
  // eslint-disable-next-line no-console
  console.info(...args);
}

export function logDebug(...args: any[]) {
  // eslint-disable-next-line no-console
  console.debug(...args);
}
